import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ModelBase } from '../model-base';
import { StoreAction } from 'store/actions';
import { ApiChannel } from 'core/constants';
import { buildHeaders, XmStore } from 'core/services';

import { AccountSummary } from './models';

@Injectable()
export class AccountSummaryApi {
    public static getAccountSummarySSMLowerSeg(_xmStore: XmStore, http: HttpClient, _params: ApiParams): Observable<AccountSummary> {
        return http.get('/xm/ot/summary?is_lowerSeg=true', {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY })
        }).pipe(
            map((response: AccountSummary) => AccountSummary.create<AccountSummary>(response))
        );
    }

    public static getSSMAccountSummaryNoLevel(_xmStore: XmStore, http: HttpClient, _params: ApiParams): Observable<AccountSummary> {
        return http.get('/xm/ot/summary?ti=true', {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY })
        }).pipe(
            map((response: AccountSummary) => AccountSummary.create<AccountSummary>(response))
        );
    }

    public static getAccountSummaryViaSSMProxy(_xmStore: XmStore, http: HttpClient, _params: ApiParams): Observable<AccountSummary> {
        return http.get('/xm/ot/summary', {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY })
        }).pipe(
            map((response: AccountSummary) => AccountSummary.create<AccountSummary>(response))
        );
    }

    public static getAccountSummaryForPlanEight(_xmStore: XmStore, http: HttpClient, _params: ApiParams): Observable<AccountSummary> {
        return http.get('/xm/ot/summary?is_plan8=true', {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY })
        }).pipe(
            map((response: AccountSummary) => AccountSummary.create<AccountSummary>(response))
        );
    }
}

ModelBase.fetchMapping[StoreAction.GET_ACCOUNT_SUMMARY] = AccountSummaryApi.getAccountSummarySSMLowerSeg;
ModelBase.fetchMapping[StoreAction.GET_SSM_ACCOUNT_SUMMARY_CBM_NO_LEVEL] = AccountSummaryApi.getSSMAccountSummaryNoLevel;
ModelBase.fetchMapping[StoreAction.GET_ACCOUNT_SUMMARY_VIA_SSM_PROXY] = AccountSummaryApi.getAccountSummaryViaSSMProxy;
ModelBase.fetchMapping[StoreAction.GET_ACCOUNT_SUMMARY_FOR_PLAN_EIGHT] = AccountSummaryApi.getAccountSummaryForPlanEight;
